/** Ключ приходит в payload только при offline; иначе отсутствует. */
export default interface OfflineDpoPayload {
  offline_dpo: true;
}

export const isOfflineDpoPayload = (payload: unknown): payload is OfflineDpoPayload =>
  !!payload &&
  typeof payload === "object" &&
  !Array.isArray(payload) &&
  "offline_dpo" in payload &&
  (payload as OfflineDpoPayload).offline_dpo === true;
